export const handleRefresh = (map, markerRef) => {
  map?.current?.flyTo({
    center: [69.3451, 30.3753],
    zoom: 5,
    bearing: 0,
  });

  if (markerRef?.current) {
    markerRef.current.remove();
    markerRef.current = null;
  }
};
